import { useSelector } from 'react-redux';
import { useGetProfessionalPromotionPayouts } from '../../../../../domain/Promotions';

// Resolves the current professional (from Redux) and fetches their promotion
// payout history, keeping ProfessionalPromotionPayouts presentational.
export const useProfessionalPromotionPayouts = () => {
  const professionalId = useSelector((state) => state.users.currentUser?.id);

  return useGetProfessionalPromotionPayouts(professionalId);
};
